<template>
<!-- <div class="login-box">
  <div class="login-logo">
    <router-link to="/"><b>Sexy</b>MM</router-link>
  </div>
  <div class="login-box-body">
    <p class="login-box-msg">Sign in to start your session</p>
    <form @submit.prevent="login" method="post">
      <div class="form-group has-feedback">
        <input v-model="credential.email"  @keyup.enter="login" type="text" class="form-control" placeholder="Email/Username">
        <span class="glyphicon glyphicon-envelope form-control-feedback"></span>
      </div>
      <div class="form-group has-feedback">
        <input v-model="credential.password"  @keyup.enter="login" type="password" class="form-control" placeholder="Password">
        <span class="glyphicon glyphicon-lock form-control-feedback"></span>
      </div>
      <div class="row">
        <div class="col-xs-4">
          <button type="submit" class="btn btn-primary btn-block btn-flat">Sign In</button>
        </div>
      </div>
    </form>
  </div>



</div> -->

<body class="layout-row">
  <div class="flex">
    <div class="w-xl w-auto-sm mx-auto py-5">
      <div class="p-4 d-flex flex-column h-100">
        <!-- brand -->
        <a href="#" class="navbar-brand align-self-center">
          <svg width="32" height="32" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
            <g class="loading-spin" style="transform-origin: 256px 256px">
              <path d="M200.043 106.067c-40.631 15.171-73.434 46.382-90.717 85.933H256l-55.957-85.933zM412.797 288A160.723 160.723 0 0 0 416 256c0-36.624-12.314-70.367-33.016-97.334L311 288h101.797zM359.973 134.395C332.007 110.461 295.694 96 256 96c-7.966 0-15.794.591-23.448 1.715L310.852 224l49.121-89.605zM99.204 224A160.65 160.65 0 0 0 96 256c0 36.639 12.324 70.394 33.041 97.366L201 224H99.204zM311.959 405.932c40.631-15.171 73.433-46.382 90.715-85.932H256l55.959 85.932zM152.046 377.621C180.009 401.545 216.314 416 256 416c7.969 0 15.799-.592 23.456-1.716L201.164 288l-49.118 89.621z"></path>
            </g>
          </svg>
          <!-- <img src="../assets/img/logo.png" alt="..."> -->
          <span class="hidden-folded d-inline l-s-n-1x align-self-center">Agent Management System</span>
        </a>
        <!-- / brand -->
      </div>
      <div class="card">
        <div id="content-body">
          <div class="p-3 p-md-5">
            <h5>Login to Your Account</h5>
           
            <form @submit.prevent="login" method="post" class="" role="form" >
              <div class="form-group">
                <label>Agent ID</label>
                <input  v-model="credential.email"  @keyup.enter="login" type="text" class="form-control" placeholder="Enter email">
              </div>
              <div class="form-group">
                <label>Password</label>
                <input v-model="credential.password"  @keyup.enter="login" type="password" class="form-control" placeholder="Password">
              </div>
             
              <button type="submit" class="btn btn-primary mb-4">Sign in</button>
            </form>
          </div>
        </div>
      </div>
      <div class="text-center text-muted">&copy; Copyright AE Sexy</div>
    </div>
  </div>
</body>





</template>


<script>
import { LOGIN, FETCH_TASKS } from '@/store/mutation-types';


export default {
  name: 'Login',
  components: {
    
  },

  data () {
    return {
      credential: {
        email: '',
        password: ''
        
      }
    }
  },

  methods: {
    login () {
      this.$http.post('login', this.credential)
      .then(({ data }) => {
        
        this.$store.commit(LOGIN, data.data)
          // this.$store.dispatch(FETCH_TASKS)
          // alert(data.message)
          window.location.replace('/');
        }, ({ data }) => {
         // data && alert(data.message)
           this.$bvToast.toast(data.message, {
              title: `Invalid Login `,
              variant: 'warning',
              toaster: 'b-toaster-top-center',
              solid: true
            })
        })
    }
  }
}
</script>